import React from "react";
import { FileText, Plus } from "lucide-react";

/**
 * Professional empty state component
 * Used when lists or sections have no data
 */
const EmptyState = ({
  icon: Icon = FileText,
  title,
  description,
  actionLabel,
  onAction,
  className = "",
}) => {
  return (
    <div
      className={`
        flex flex-col items-center justify-center
        py-16 px-6 text-center
        bg-gray-50 rounded-xl border-2 border-dashed border-gray-200
        ${className}
      `}
    >
      {/* Icon */}
      <div className="w-16 h-16 mb-4 rounded-full bg-gray-100 flex items-center justify-center">
        <Icon className="w-8 h-8 text-gray-400" />
      </div>

      {/* Title */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>

      {/* Description */}
      {description && (
        <p className="text-sm text-gray-500 mb-6 max-w-md">{description}</p>
      )}

      {/* Action Button */}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="
            inline-flex items-center gap-2 px-4 py-2
            bg-blue-600 text-white text-sm font-medium
            rounded-lg hover:bg-blue-700
            transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          "
        >
          <Plus className="w-4 h-4" />
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;


